[
  {
    "id": "340",
    "name": "Honey",
    "description": "It's a sweet syrup produced by bees.",
    "equipment": "Bee House",
    "ingredients": [
      {
        "name": "Flower (nearby)",
        "id": null,
        "quantity": null
      }
    ],
    "processingMinutes": 6400,
    "processingDays": 4,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "100g for wild honey; 2× nearby flower base price + 100 for flower honey",
    "priceFormula": {
      "multiplier": 2,
      "addend": 100
    },
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Honey.png",
    "maxQuality": "base"
  },
  {
    "id": "348",
    "name": "Wine",
    "description": "Drink in moderation.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Any Fruit",
        "id": null,
        "quantity": 1
      }
    ],
    "processingMinutes": 10000,
    "processingDays": 6.25,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "3× base fruit price",
    "priceFormula": {
      "multiplier": 3,
      "addend": 0
    },
    "qualityLevels": true,
    "cask": {
      "silverDays": 14,
      "goldDays": 28,
      "iridiumDays": 56
    },
    "energyHealthFormula": "1.75× base fruit energy & health",
    "energyHealth": null,
    "buffs": [
      {
        "stat": "Speed",
        "value": -1
      }
    ],
    "buffDuration": null,
    "image": "images/artisan-goods/Wine.png",
    "maxQuality": "iridium"
  },
  {
    "id": "350",
    "name": "Juice",
    "description": "A sweet, nutritious beverage.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Any Vegetable",
        "id": null,
        "quantity": 1
      }
    ],
    "processingMinutes": 6000,
    "processingDays": 3.75,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "2.25× base vegetable price",
    "priceFormula": {
      "multiplier": 2.25,
      "addend": 0
    },
    "qualityLevels": true,
    "cask": {
      "silverDays": 14,
      "goldDays": 28,
      "iridiumDays": 56
    },
    "energyHealthFormula": "2× base vegetable energy & health",
    "energyHealth": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Juice.png",
    "maxQuality": "iridium"
  },
  {
    "id": "303",
    "name": "Pale Ale",
    "description": "Drink in moderation.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Hops",
        "id": "304",
        "quantity": 1
      }
    ],
    "processingMinutes": 2250,
    "processingDays": 1.41,
    "sellPrice": 300,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": true,
    "cask": {
      "silverDays": 9,
      "goldDays": 18,
      "iridiumDays": 36
    },
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 50,
      "health": 22
    },
    "buffs": [
      {
        "stat": "Speed",
        "value": -1
      }
    ],
    "buffDuration": null,
    "image": "images/artisan-goods/Pale Ale.png",
    "maxQuality": "iridium"
  },
  {
    "id": "346",
    "name": "Beer",
    "description": "Drink in moderation.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Wheat",
        "id": "262",
        "quantity": 1
      }
    ],
    "processingMinutes": 1750,
    "processingDays": 1.09,
    "sellPrice": 200,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": true,
    "cask": {
      "silverDays": 7,
      "goldDays": 14,
      "iridiumDays": 28
    },
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 50,
      "health": 22
    },
    "buffs": [
      {
        "stat": "Speed",
        "value": -1
      }
    ],
    "buffDuration": null,
    "image": "images/artisan-goods/Beer.png",
    "maxQuality": "iridium"
  },
  {
    "id": "459",
    "name": "Mead",
    "description": "Drink in moderation.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Honey",
        "id": "340",
        "quantity": 1
      }
    ],
    "processingMinutes": 600,
    "processingDays": 0.38,
    "sellPrice": 300,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": true,
    "cask": {
      "silverDays": 7,
      "goldDays": 14,
      "iridiumDays": 28
    },
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 75,
      "health": 33
    },
    "buffs": [
      {
        "stat": "Speed",
        "value": -1
      }
    ],
    "buffDuration": null,
    "image": "images/artisan-goods/Mead.png",
    "maxQuality": "iridium"
  },
  {
    "id": "395",
    "name": "Coffee",
    "description": "It smells delicious. This is sure to give you a boost.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Coffee Bean",
        "id": "433",
        "quantity": 5
      }
    ],
    "processingMinutes": 120,
    "processingDays": 0.08,
    "sellPrice": 150,
    "profession": [],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 3,
      "health": 1
    },
    "buffs": [
      {
        "stat": "Speed",
        "value": 1
      }
    ],
    "buffDuration": null,
    "image": "images/artisan-goods/Coffee.png",
    "maxQuality": "base"
  },
  {
    "id": "419",
    "name": "Vinegar",
    "description": "A fermented liquid used in cooking and preservation.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Rice",
        "id": "423",
        "quantity": 1
      }
    ],
    "processingMinutes": 600,
    "processingDays": 0.38,
    "sellPrice": 100,
    "profession": [],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 13,
      "health": 5
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Vinegar.png",
    "maxQuality": "base"
  },
  {
    "id": "614",
    "name": "Green Tea",
    "description": "A soothing beverage made from tea leaves.",
    "equipment": "Keg",
    "ingredients": [
      {
        "name": "Tea Leaves",
        "id": "815",
        "quantity": 1
      }
    ],
    "processingMinutes": 180,
    "processingDays": 0.11,
    "sellPrice": 100,
    "profession": [],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 13,
      "health": 5
    },
    "buffs": [
      {
        "stat": "Speed",
        "value": 0.5
      }
    ],
    "buffDuration": null,
    "image": "images/artisan-goods/Green Tea.png",
    "maxQuality": "base"
  },
  {
    "id": "344",
    "name": "Jelly",
    "description": "A sweet fruit preserve.",
    "equipment": "Preserves Jar",
    "ingredients": [
      {
        "name": "Any Fruit",
        "id": null,
        "quantity": 1
      }
    ],
    "processingMinutes": 4000,
    "processingDays": 2.5,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "50 + 2× base fruit price",
    "priceFormula": {
      "multiplier": 2,
      "addend": 50
    },
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": "2× base fruit energy & health",
    "energyHealth": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Jelly.png",
    "maxQuality": "base"
  },
  {
    "id": "342",
    "name": "Pickles",
    "description": "A jar of your home-grown pickles.",
    "equipment": "Preserves Jar",
    "ingredients": [
      {
        "name": "Any Vegetable",
        "id": null,
        "quantity": 1
      }
    ],
    "processingMinutes": 4000,
    "processingDays": 2.5,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "50 + 2× base vegetable price",
    "priceFormula": {
      "multiplier": 2,
      "addend": 50
    },
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": "1.75× base vegetable energy & health",
    "energyHealth": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Pickles.png",
    "maxQuality": "base"
  },
  {
    "id": "447",
    "name": "Aged Roe",
    "description": "Aged to a delicate, complex flavor.",
    "equipment": "Preserves Jar",
    "ingredients": [
      {
        "name": "Roe",
        "id": "812",
        "quantity": 1
      }
    ],
    "processingMinutes": 4000,
    "processingDays": 2.5,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "2× base roe price",
    "priceFormula": {
      "multiplier": 2,
      "addend": 0
    },
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 100,
      "health": 45
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Aged Roe.png",
    "maxQuality": "base"
  },
  {
    "id": "445",
    "name": "Caviar",
    "description": "Fish eggs prepared with care.",
    "equipment": "Preserves Jar",
    "ingredients": [
      {
        "name": "Sturgeon Roe",
        "id": "812S",
        "quantity": 1
      }
    ],
    "processingMinutes": 6000,
    "processingDays": 3.75,
    "sellPrice": 500,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 175,
      "health": 78
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Caviar.png",
    "maxQuality": "base"
  },
  {
    "id": "424",
    "name": "Cheese",
    "description": "It's a basic necessity of life.",
    "equipment": "Cheese Press",
    "ingredients": [
      {
        "name": "Milk",
        "id": "184",
        "quantity": 1
      },
      {
        "name": "Large Milk",
        "id": "186",
        "quantity": 1
      }
    ],
    "processingMinutes": 200,
    "processingDays": 0.13,
    "sellPrice": 230,
    "profession": ["artisan"],
    "sellPriceFormula": "Large Milk produces Gold quality (345g)",
    "priceFormula": null,
    "qualityLevels": true,
    "cask": {
      "silverDays": 7,
      "goldDays": 14,
      "iridiumDays": 28
    },
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 125,
      "health": 56
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Cheese.png",
    "maxQuality": "iridium"
  },
  {
    "id": "426",
    "name": "Goat Cheese",
    "description": "Soft cheese made from goat's milk.",
    "equipment": "Cheese Press",
    "ingredients": [
      {
        "name": "Goat Milk",
        "id": "436",
        "quantity": 1
      },
      {
        "name": "Large Goat Milk",
        "id": "438",
        "quantity": 1
      }
    ],
    "processingMinutes": 200,
    "processingDays": 0.13,
    "sellPrice": 400,
    "profession": ["artisan"],
    "sellPriceFormula": "Large Goat Milk produces Gold quality (600g)",
    "priceFormula": null,
    "qualityLevels": true,
    "cask": {
      "silverDays": 7,
      "goldDays": 14,
      "iridiumDays": 28
    },
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 125,
      "health": 56
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Goat Cheese.png",
    "maxQuality": "iridium"
  },
  {
    "id": "428",
    "name": "Cloth",
    "description": "A bolt of fine wool cloth.",
    "equipment": "Loom",
    "ingredients": [
      {
        "name": "Wool",
        "id": "440",
        "quantity": 1
      }
    ],
    "processingMinutes": 240,
    "processingDays": 0.15,
    "sellPrice": 470,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Cloth.png",
    "maxQuality": "base"
  },
  {
    "id": "432",
    "name": "Truffle Oil",
    "description": "A gourmet cooking ingredient.",
    "equipment": "Oil Maker",
    "ingredients": [
      {
        "name": "Truffle",
        "id": "430",
        "quantity": 1
      }
    ],
    "processingMinutes": 360,
    "processingDays": 0.23,
    "sellPrice": 1065,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 38,
      "health": 17
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Truffle Oil.png",
    "maxQuality": "base"
  },
  {
    "id": "247",
    "name": "Oil",
    "description": "A multipurpose cooking oil.",
    "equipment": "Oil Maker",
    "ingredients": [
      {
        "name": "Sunflower",
        "id": "421",
        "quantity": 1
      },
      {
        "name": "Sunflower Seeds",
        "id": "431",
        "quantity": 1
      },
      {
        "name": "Corn",
        "id": "270",
        "quantity": 1
      }
    ],
    "processingMinutes": 1000,
    "processingDays": 0.63,
    "sellPrice": 100,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 13,
      "health": 5
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Oil.png",
    "maxQuality": "base"
  },
  {
    "id": "306",
    "name": "Mayonnaise",
    "description": "It's a thick, creamy sauce.",
    "equipment": "Mayonnaise Machine",
    "ingredients": [
      {
        "name": "Egg",
        "id": "176",
        "quantity": 1
      },
      {
        "name": "Large Egg",
        "id": "174",
        "quantity": 1
      },
      {
        "name": "Brown Egg",
        "id": "180",
        "quantity": 1
      },
      {
        "name": "Large Brown Egg",
        "id": "182",
        "quantity": 1
      },
      {
        "name": "Golden Egg",
        "id": "928",
        "quantity": 1
      }
    ],
    "processingMinutes": 180,
    "processingDays": 0.11,
    "sellPrice": 190,
    "profession": ["artisan"],
    "sellPriceFormula": "Large Egg produces 2× Mayonnaise; Golden Egg produces Gold quality",
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 50,
      "health": 22
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Mayonnaise.png",
    "maxQuality": "base"
  },
  {
    "id": "307",
    "name": "Duck Mayonnaise",
    "description": "This mayonnaise was made with a duck egg.",
    "equipment": "Mayonnaise Machine",
    "ingredients": [
      {
        "name": "Duck Egg",
        "id": "442",
        "quantity": 1
      }
    ],
    "processingMinutes": 180,
    "processingDays": 0.11,
    "sellPrice": 375,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 75,
      "health": 33
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Duck Mayonnaise.png",
    "maxQuality": "base"
  },
  {
    "id": "308",
    "name": "Void Mayonnaise",
    "description": "A dark, mysterious condiment.",
    "equipment": "Mayonnaise Machine",
    "ingredients": [
      {
        "name": "Void Egg",
        "id": "305",
        "quantity": 1
      }
    ],
    "processingMinutes": 180,
    "processingDays": 0.11,
    "sellPrice": 275,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": -75,
      "health": 0,
      "poison": true
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Void Mayonnaise.png",
    "maxQuality": "base"
  },
  {
    "id": "807",
    "name": "Dinosaur Mayonnaise",
    "description": "It's thick and creamy, with a distinct prehistoric smell.",
    "equipment": "Mayonnaise Machine",
    "ingredients": [
      {
        "name": "Dinosaur Egg",
        "id": "107",
        "quantity": 1
      }
    ],
    "processingMinutes": 180,
    "processingDays": 0.11,
    "sellPrice": 800,
    "profession": ["artisan"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 125,
      "health": 56
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Dinosaur Mayonnaise.png",
    "maxQuality": "base"
  },
  {
    "id": "Raisins",
    "name": "Raisins",
    "description": "Dried grapes. They have a very sweet flavor.",
    "equipment": "Dehydrator",
    "ingredients": [
      {
        "name": "Grape",
        "id": "398",
        "quantity": 5
      }
    ],
    "processingMinutes": 1600,
    "processingDays": 1,
    "sellPrice": 600,
    "profession": [],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 125,
      "health": 56
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Raisins.png",
    "maxQuality": "base"
  },
  {
    "id": "DriedFruit",
    "name": "Dried Fruit",
    "description": "A sweet and chewy snack.",
    "equipment": "Dehydrator",
    "ingredients": [
      {
        "name": "Any Fruit",
        "id": null,
        "quantity": 5
      }
    ],
    "processingMinutes": 1600,
    "processingDays": 1,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "2.5× base fruit price",
    "priceFormula": {
      "multiplier": 2.5,
      "addend": 0
    },
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": "3× base fruit energy & health",
    "energyHealth": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Dried Fruit.png",
    "maxQuality": "base"
  },
  {
    "id": "DriedMushrooms",
    "name": "Dried Mushrooms",
    "description": "Concentrated mushroom flavor. Goes great in soups.",
    "equipment": "Dehydrator",
    "ingredients": [
      {
        "name": "Any Edible Mushroom",
        "id": null,
        "quantity": 2
      }
    ],
    "processingMinutes": 1600,
    "processingDays": 1,
    "sellPrice": null,
    "profession": ["artisan"],
    "sellPriceFormula": "2.5× base mushroom price",
    "priceFormula": {
      "multiplier": 2.5,
      "addend": 0
    },
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": "3× base mushroom energy & health",
    "energyHealth": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Dried Mushrooms.png",
    "maxQuality": "base"
  },
  {
    "id": "SmokedFish",
    "name": "Smoked Fish",
    "description": "Preserving fish through smoking gives it a rich, complex flavor.",
    "equipment": "Fish Smoker",
    "ingredients": [
      {
        "name": "Any Fish",
        "id": null,
        "quantity": 1
      }
    ],
    "processingMinutes": 50,
    "processingDays": 0.03,
    "sellPrice": null,
    "profession": ["fisher", "artisan", "angler"],
    "sellPriceFormula": "2× base fish sell price",
    "priceFormula": {
      "multiplier": 2,
      "addend": 0
    },
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": "1.5× base fish energy & health",
    "energyHealth": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Smoked Fish.png",
    "maxQuality": "base"
  },
  {
    "id": "MysticSyrup",
    "name": "Mystic Syrup",
    "description": "A syrup with a powerful magical essence.",
    "equipment": "Tapper",
    "ingredients": [
      {
        "name": "Mystic Tree",
        "id": null,
        "quantity": 1
      }
    ],
    "processingMinutes": 10080,
    "processingDays": 7,
    "sellPrice": 1000,
    "profession": ["tapper"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 500,
      "health": 225
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/artisan-goods/Mystic Syrup.png",
    "maxQuality": "base"
  },
  {
    "id": "724",
    "name": "Maple Syrup",
    "description": "A sweet syrup with a unique flavor.",
    "equipment": "Tapper",
    "ingredients": [
      {
        "name": "Maple Tree",
        "id": "2",
        "quantity": 1
      }
    ],
    "processingMinutes": 14400,
    "processingDays": 9,
    "sellPrice": 200,
    "profession": ["tapper"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "energyHealth": {
      "energy": 50,
      "health": 22
    },
    "buffs": [],
    "buffDuration": null,
    "image": "images/forageables/Maple Syrup.png",
    "maxQuality": "base"
  },
  {
    "id": "725",
    "name": "Oak Resin",
    "description": "A sticky, fragrant substance obtained from oak trees.",
    "equipment": "Tapper",
    "ingredients": [
      {
        "name": "Oak Tree",
        "id": "1",
        "quantity": 1
      }
    ],
    "processingMinutes": 11200,
    "processingDays": 7,
    "sellPrice": 150,
    "profession": ["tapper"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/forageables/Oak Resin.png",
    "maxQuality": "base"
  },
  {
    "id": "726",
    "name": "Pine Tar",
    "description": "A dark, sticky substance derived from pine trees.",
    "equipment": "Tapper",
    "ingredients": [
      {
        "name": "Pine Tree",
        "id": "3",
        "quantity": 1
      }
    ],
    "processingMinutes": 8000,
    "processingDays": 5,
    "sellPrice": 100,
    "profession": ["tapper"],
    "sellPriceFormula": null,
    "priceFormula": null,
    "qualityLevels": false,
    "cask": null,
    "energyHealthFormula": null,
    "buffs": [],
    "buffDuration": null,
    "image": "images/forageables/Pine Tar.png",
    "maxQuality": "base"
  }
]
